// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2R2An","head":"Table_head__1VUTL","col":"Table_col__hXix4"};